import { TextField } from "@mui/material";
import { WindowedAutocomplete } from "src/components";
import { useGetAllTaskItems } from "src/http";

interface Props {
  contextTaskItemGuid?: string | undefined;
  value: string | null;
  onChange: (taskItemGuid: string | null) => void;
  disabled?: boolean;
}

const TaskItemAutocomplete = (props: Props) => {
  const { data, isLoading } = useGetAllTaskItems(props.contextTaskItemGuid);

  return (
    <WindowedAutocomplete
      isLoading={isLoading}
      disabled={isLoading || props.disabled}
      options={
        data?.taskItems
          ? [...data.taskItems]
              .filter((x) => x.taskItemGuid !== props.contextTaskItemGuid && !x.isChild)
              .sort((a, b) => a.description.localeCompare(b.description))
              .map((x) => x.taskItemGuid)
          : []
      }
      getOptionLabel={(taskItemGuid) => data?.taskItems.find((x) => x.taskItemGuid === taskItemGuid)?.description ?? ""}
      renderInput={(params) => <TextField {...params} placeholder="Select a task..." />}
      onChange={(_, value) => props.onChange(value)}
      value={props.value}
    />
  );
};

export { TaskItemAutocomplete };
